import { BaSeLoading, BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Container,
  Content,
  HeaderInfo,
  Retangle,
} from './johari-windo-graph-style';

import { useReport } from '../hook/useReport';

const dataDefault = {
  labels: [],
  datasets: [
    {
      label: 'Cores',
      data: [300, 50, 100],
      backgroundColor: [
        'rgba(116, 89, 217, 1)',
        '#b9abeb',
        'rgba(227, 222, 247, 1)',
      ],
      borderWidth: 4,
      borderRadius: 60,
    },
  ],
};

function JohariWindowGraph() {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [data, setData] = React.useState(dataDefault);
  const [proxomyti, setProxomyti] = React.useState({});
  const [numevPalavras, setNuvemPalavras] = React.useState('');
  const [erro, setErro] = React.useState();
  const [showStep, setShowStep] = React.useState();

  React.useEffect(() => {
    getStepData({ cpf: getRouteParam('cpf'), step: 'JANELAS_JOHARI' })
      .then(({ showStep, data }) => {
        setShowStep(showStep);
        console.log(data);
        const dataFormated = {
          labels: [],
          datasets: [
            {
              label: 'Cores',
              data: [
                data.proxomytiData.seriesOne,
                data.proxomytiData.seriesTwo,
                data.proxomytiData.seriesThree,
              ],
              backgroundColor: [
                'rgba(116, 89, 217, 1)',
                '#b9abeb',
                'rgba(227, 222, 247, 1)',
              ],
              borderWidth: 4,
              borderRadius: 60,
            },
          ],
        };
        setData(dataFormated);
        setProxomyti(data.proxomytiData);
        setNuvemPalavras(data.wordCloudUrl);
      })
      .catch((error) => {
        setErro(error);
        //       console.log('deu erro', error);
      });
  }, [getRouteParam, getStepData]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
      },
    },
    cutout: '80%',
  };

  if (laoding) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }
  if (!showStep) {
    return <> </>;
  }
  return (
    <div>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        JANELA DE JOHARI
      </BaSeParagraph>
      {erro && 'Não foi possíivel carregar os dados dessa sessão do relatório!'}

      <Container>
        <div>
          <HeaderInfo>
            <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white}>
              Qual seu grau de proximidade comigo?
            </BaSeSmall1>
          </HeaderInfo>
          <Content>
            <div style={{ width: '40%' }}>
              <Doughnut data={data} options={options} />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}
              >
                <Retangle color="#7459D9" />
                <div>
                  <BaSeSmall1>
                    Somos próximos ou parentes e nos falamos sempre.
                  </BaSeSmall1>
                  <BaSeParagraph isBold>{proxomyti.seriesOne} %</BaSeParagraph>
                </div>
              </div>

              <div
                style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}
              >
                <Retangle color="#B9ABEB" />
                <div>
                  <BaSeSmall1>
                    Somos apenas conhecidos sem laços muito pessoais.
                  </BaSeSmall1>
                  <BaSeParagraph isBold>{proxomyti.seriesTwo} % </BaSeParagraph>
                </div>
              </div>

              <div
                style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}
              >
                <Retangle color="#E3DEF7" />
                <div>
                  <BaSeSmall1>
                    Somos próximos ou parentes e nos falamos sempre.
                  </BaSeSmall1>
                  <BaSeParagraph isBold>
                    {proxomyti.seriesThree} %
                  </BaSeParagraph>
                </div>
              </div>
            </div>
          </Content>
        </div>
        <div>
          <HeaderInfo>
            <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white}>
              Adjetivos marcantes
            </BaSeSmall1>
          </HeaderInfo>
          <div>
            <img src={numevPalavras} alt="teste" width="80%" />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default JohariWindowGraph;
